import {
  makeStyles,
  Button,
} from "@material-ui/core";
import { ITheme } from "../constants/theme";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";

interface IProps {
  onClick?: () => void;
  disabled?: boolean;
}

export const CancelButton = ({ onClick, disabled }: IProps) => {
  const classes = useStyles();

  return (
    <Button onClick={onClick} disabled={disabled} className={disabled ? classes.disabled : classes.cancelButton}>
      Cancel
    </Button>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  cancelButton: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    color: theme.palette.primary.main,
    marginRight: "8px",
    ...textButtonHoverAndActive
  },
  disabled: {
    width: "80px",
    height: "48px",
    borderRadius: "8px",
    padding: "6px 16px",
    backgroundColor: theme.palette.action.disabledBackground,
    color: theme.palette.action.disabled,
    marginRight: "8px",
  },
}));